<template>
  <div class="booking-form"
    v-bind:class="{ 'show': !this.isOrderCompleted && isActive, 'animate__animated animate__fadeOutRight': this.isOrderCompleted && isActive }">
    <div class="form-title"> Ваш заказ </div>
    <div class="form-details-wrapper">
      <div class="form-details" v-if="getDateStart">
        <div class="form-details-label"> Дата: </div>
        <div class="form-details-value"> {{ getDateStart.format('DD MMM yyyy') }} - {{ getDateEnd.format('DD MMM yyyy')
        }} </div>
      </div>
      <div class="form-details" v-if="getTimeEnd">
        <div class="form-details-label"> Время: </div>
        <div class="form-details-value"> {{ getTimeStart }} - {{ getTimeEnd }} </div>
      </div>
      <div class="form-details">
        <div class="form-details-label"> Цена: </div>
        <div class="form-details-value"> {{ getOrderPrice }} </div>
      </div>
    </div>
    <div class="input-wrapper">
      <IconInput label="Ваше имя *" placeholder="John" type="text" v-model="username" :error="usernameError">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M16.6666 17.5V15.8333C16.6666 14.9493 16.3155 14.1014 15.6903 13.4763C15.0652 12.8512 14.2174 12.5 13.3333 12.5H6.66665C5.78259 12.5 4.93474 12.8512 4.30962 13.4763C3.6845 14.1014 3.33331 14.9493 3.33331 15.8333V17.5M13.3333 5.83333C13.3333 7.67428 11.8409 9.16667 9.99998 9.16667C8.15903 9.16667 6.66665 7.67428 6.66665 5.83333C6.66665 3.99238 8.15903 2.5 9.99998 2.5C11.8409 2.5 13.3333 3.99238 13.3333 5.83333Z"
            stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </IconInput>
      <IconInput label="Ваша почта *" placeholder="you@mail" type="email" v-model="mail" :error="mailError">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M18.3334 4.99992C18.3334 4.08325 17.5834 3.33325 16.6667 3.33325H3.33335C2.41669 3.33325 1.66669 4.08325 1.66669 4.99992M18.3334 4.99992V14.9999C18.3334 15.9166 17.5834 16.6666 16.6667 16.6666H3.33335C2.41669 16.6666 1.66669 15.9166 1.66669 14.9999V4.99992M18.3334 4.99992L10 10.8333L1.66669 4.99992"
            stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </IconInput>
      <div class="button-wrapper">
        <custom-button button-text="Отмена" button-type="reset" :isBlocked="false" @clicked="closeForm" />
        <custom-button button-text="Подтвердить" button-type="apply" :is-blocked="!isUsernameValid"
          @clicked="validateAndSubmit" />
      </div>
    </div>
  </div>
</template>

<script>
  import IconInput from '../Inputs/IconInput.vue'
  import CustomButton from '../Inputs/CustomButton.vue'
  import apiClient from "../../../apiClient";

  export default {
    name: 'BookingForm',
    components: { CustomButton, IconInput },
    props: ['isActive'],
    data() {
      return {
        isOrderCompleted: false,
        username: '',
        mail: '',
        usernameError: '',
        mailError: '',
        formSubmitted: false
      }
    },
    computed: {
      getTimeStart() {
        return this.$store.state.selectedStartTime
      },
      getTimeEnd() {
        return this.$store.state.selectedEndTime
      },
      getDateStart() {
        return this.$store.state.selectedStartDate
      },
      getDateEnd() {
        return this.$store.state.selectedEndDate
      },
      isMailValid() {
        return (/.+?\@.+/g).test(this.mail) && this.mail.length > 2
      },
      isUsernameValid() {
        return this.username.length >= 2
      },
      isFormValid() {
        return this.isMailValid && this.isUsernameValid
      },
      getOrderPrice() {
        return this.$store.getters.orderPrice
      }
    },
    watch: {
      username(val) {
        if (this.formSubmitted) {
          this.validateUsername()
        }
      },
      mail(val) {
        if (this.formSubmitted) {
          this.validateEmail()
        }
      }
    },
    methods: {
      validateUsername() {
        if (!this.username || this.username.length < 2) {
          this.usernameError = 'Имя должно содержать минимум 2 символа'
          return false
        }
        this.usernameError = ''
        return true
      },
      validateEmail() {
        if (!this.mail) {
          this.mailError = 'Введите email'
          return false
        }
        if (!(/.+?\@.+/g).test(this.mail)) {
          this.mailError = 'Введите корректный email'
          return false
        }
        this.mailError = ''
        return true
      },
      validateAndSubmit() {
        this.formSubmitted = true

        const isUsernameValid = this.validateUsername()
        const isEmailValid = this.validateEmail()

        if (isUsernameValid && isEmailValid) {
          this.completeForm()
        }
      },
      completeForm() {
        let data = {
          orderType: 'DEFAULT',
          order: {
            placeIdList: Array.from(this.$store.state.selectedPlaceSet),
            dayStart: this.$store.state.selectedStartDate.format('DD-MM-yyyy'),
            dayEnd: this.$store.state.selectedEndDate ? this.$store.state.selectedEndDate.format('DD-MM-yyyy') : this.$store.state.selectedStartDate.format('DD-MM-yyyy'),
            timeStart: this.$store.state.selectedStartTime,
            timeEnd: this.$store.state.selectedEndTime,
            mail: this.mail,
            username: this.username
          }
        }

        apiClient.post('/api/order', data).then(response => {
          this.isOrderCompleted = true
          this.$emit('completed', this.mail)
        })
      },
      closeForm() {
        this.$emit('closed')
      }
    }
  }
</script>

<style scoped>
.booking-form {
  padding: 24px;
  display: none;
  width: fit-content;
  flex-direction: column;
  border-radius: 12px;
  background: #FFF;
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);
}

.booking-form.show {
  display: flex;
}

.form-title {
  color: #101828;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-bottom: 8px;
}

.form-details-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-details {
  display: flex;
  flex-direction: row;
}

.form-details-label {
  padding: 8px 14px;
  color: #101828;
  width: 40px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
}

.form-details-value {
  padding: 8px 14px;
  color: #101828;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  gap: 12px;
}

.button-wrapper {
  padding-top: 20px;
  display: flex;
  gap: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/Forms/BookingForm.vue